module.exports = __webpack_public_path__ + "assets/img/NPC010.e2d35621.png";